const AUTO_LOGIN_KEY = 'track:auto_login';
const STALE_WINDOW_MS = 2 * 60 * 1000;

export const shouldAttemptAutoLogin = () => {
  const raw = sessionStorage.getItem(AUTO_LOGIN_KEY);
  if (!raw) return true;
  const timestamp = Number(raw);
  if (Number.isNaN(timestamp)) return true;
  return Date.now() - timestamp > STALE_WINDOW_MS;
};

export const markAutoLoginAttempt = () => {
  sessionStorage.setItem(AUTO_LOGIN_KEY, String(Date.now()));
};

export const clearAutoLoginAttempt = () => {
  sessionStorage.removeItem(AUTO_LOGIN_KEY);
};

export const stashRedirectPath = () => {
  sessionStorage.setItem(
    'redirect',
    window.location.pathname + window.location.search
  );
};

let isLoginRedirectPending = false;

// An unfocused tab sent to /login sits on a OneLogin page whose state goes
// stale before the user comes back, so wait until the tab has focus.
export const redirectToLoginWhenActive = () => {
  const redirect = () => {
    markAutoLoginAttempt();
    stashRedirectPath();
    window.location.href = '/login';
  };

  if (document.hasFocus()) {
    redirect();
    return;
  }
  if (isLoginRedirectPending) return;
  isLoginRedirectPending = true;

  window.addEventListener(
    'focus',
    () => {
      isLoginRedirectPending = false;
      redirect();
    },
    {once: true}
  );
};

const SWITCHING_ACCOUNT_KEY = 'track:switching_account';
// Covers the OneLogin logout iframe wait in handleSwitchAccount, plus a margin.
const SWITCHING_ACCOUNT_WINDOW_MS = 10 * 1000;

export const markSwitchingAccount = () => {
  sessionStorage.setItem(SWITCHING_ACCOUNT_KEY, String(Date.now()));
};

// Time-bounded so an interrupted switch-account flow (redirect never completes)
// can't permanently suppress the "Authentication Required" screen.
export const isSwitchingAccount = () => {
  const raw = sessionStorage.getItem(SWITCHING_ACCOUNT_KEY);
  if (!raw) return false;
  const timestamp = Number(raw);
  if (Number.isNaN(timestamp)) return false;
  return Date.now() - timestamp <= SWITCHING_ACCOUNT_WINDOW_MS;
};

export const clearSwitchingAccount = () => {
  sessionStorage.removeItem(SWITCHING_ACCOUNT_KEY);
};
